module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/184-sweden-4dcdb9dce736bb3166507cb6100e01a2.svg";